/**
 * Copyright IBM Corp. 2019, 2023
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * Code generated by @carbon/icon-build-helpers. DO NOT EDIT.
 */
import { c as createSVGComponent } from '../utils-9450cd75.js';
import '@carbon/icon-helpers';
import 'vue';

const ChevronDown24 = createSVGComponent('ChevronDown24', {
  "xmlns": "http://www.w3.org/2000/svg",
  "viewBox": "0 0 32 32",
  "fill": "currentColor",
  "width": 24,
  "height": 24
}, [{
  "elem": "path",
  "attrs": {
    "d": "M16 22L6 12 7.4 10.6 16 19.2 24.6 10.6 26 12z"
  }
}]);

export { ChevronDown24 as default };
